<template lang="pug">
v-tabs(background-color="primary" v-model="activeTab")
  v-tab(
    v-for="tab in tabs"
    :key="tab.name"
    @click="switchTab(tab.name)"
    :data-test="tab.dataTest"
  )
    div
      div {{ tab.label }}
      div ({{ tab.count }})
</template>

<script>
export default {
  props: {
    candidatesCount: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    activeTab: 0
  }),
  computed: {
    tabs() {
      return [ 
        {
          name: this.$ROUTER_NAMES.CANDIDATES_TASKS,
          label: 'Tasks',
          count: this.candidatesCount.tasks,
          dataTest: 'c-tab-task'
        },
        {
          name: this.$ROUTER_NAMES.CANDIDATES_WAIT,
          label: 'Wait',
          count: this.candidatesCount.wait,
          dataTest: 'c-tab-wait'
        },
        {
          name: this.$ROUTER_NAMES.CANDIDATES_RESERVE_EXCHANGE,
          label: 'Reserve and exchange queue',
          count: this.candidatesCount.reserveExchange,
        },
        {
          name: this.$ROUTER_NAMES.CANDIDATES_RESERVED_EXCHANGED,
          label: 'Reserved and exchanged',
          count: this.candidatesCount.reservedExchanged
        },
        {
          name: this.$ROUTER_NAMES.CANDIDATES_PROCESSED,
          label: 'Processed',
          count: this.candidatesCount.processed
        },
        {
          name: this.$ROUTER_NAMES.CANDIDATES_ALL,
          label: 'All',
          count: this.candidatesCount.all
        },
      ]}
  },

  mounted() {
    this.setTabByQuery() 
  },

  methods: {
    switchTab(name) {
      this.$emit('changed')
      this.$router.push({name: name, query: {
        city: this.$route.query.city,
        search: this.$route.query.search
      }})
    },

    setTabByQuery() {
      let name = this.$route.name
      let tabIndex = this.tabs.findIndex(tab => tab.name === name)
      if(tabIndex < 0) return
      this.activeTab = tabIndex
    }
  }
}
</script>